import {
  FETCH_PRIVACY_SETTINGS_REQUEST,
  FETCH_PRIVACY_SETTINGS_SUCCESS,
  FETCH_PRIVACY_SETTINGS_FAILURE,
} from "../actions/types";

const initialState = {
  settings: [],
  loading: false,
  error: null,
};

const privacySettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRIVACY_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PRIVACY_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: action.payload || [],
        error: null,
      };
    case FETCH_PRIVACY_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        settings: [],
      };
    default:
      return state;
  }
};

export default privacySettingsReducer;
